import { MonsterSearch } from 'wisestep-api';

import BasicSearchForm from '../../types/IBasicSearchForm';

const countryMap = {
  AUT: 'AT',
  BEL: 'BE',
  CAN: 'CA',
  FRA: 'FR',
  DEU: 'DE',
  IRL: 'IE',
  ITA: 'IT',
  LUX: 'LU',
  NLD: 'NL',
  ESP: 'ES',
  SWE: 'SE',
  CHE: 'CH',
  GBR: 'UK',
  USA: 'US',
  all: 'all',
};

const countryCodeMap = {
  AL: '152',
  AD: '151',
  AM: '153',
  AT: '155',
  AZ: '94',
  BY: '159',
  BE: '157',
  BA: '156',
  BG: '158',
  HR: '171',
  CZ: '162',
  DK: '164',
  EE: '165',
  FI: '167',
  FR: '168',
  GE: '97',
  DE: '163',
  GR: '170',
  HU: '172',
  IS: '174',
  IE: '173',
  IT: '175',
  KZ: '107',
  KG: '103',
  LV: '179',
  LI: '176',
  LT: '177',
  LU: '178',
  MK: '182',
  MT: '183',
  MD: '181',
  MC: '180',
  NL: '184',
  NO: '185',
  PL: '186',
  PT: '187',
  RO: '188',
  RU: '189',
  SM: '31',
  SK: '161',
  SI: '191',
  ES: '166',
  SE: '190',
  CH: '160',
  TJ: '118',
  TR: '220',
  TM: '119',
  UK: '193',
  UA: '192',
  UZ: '121',
  VA: '200',
  YU: '201',
  US: '164',
};

export default function (values: BasicSearchForm & MonsterSearch, searchCriteria?: string) {
  let countryCode = (values.accountId.substring(values.accountId.indexOf('(')).split('_')[1] ?? '')
    .replace(')', '')
    .trim();
  const query: MonsterSearch = {
    ...values,
    // resumesPostedWithinDays: values.lastActive,
    q: values.query,
    pagesize: values.pageSize,
    mdatemaxage: values.lastActive,
    clv: values.clvArr ? values.clvArr.join(',') : '',
    gsc: values.gscArr ? values.gscArr.join(',') : '',
    globalSecurityClearance: values.pgscArr ? values.pgscArr.join(',') : '',
    gmi: values.gmiArr ? values.gmiArr.join(',') : '',
    qrjt: values.qrjtArr ? values.qrjtArr.join(',') : '',
    qtjt: values.qtjtArr ? values.qtjtArr.join(',') : '',
    qrcn: values.qrcnArr ? values.qrcnArr.join(',') : '',
    qrjd: values.qrjdArr ? values.qrjdArr.join(',') : '',
    qsn: values.qsnArr ? values.qsnArr.join(',') : '',
  };
  if (values.selectedCountry) {
    query.co = countryMap[values.selectedCountry];
  }
  if ('europe' === countryCode && !values.zipcode) {
    countryCode = 'UK';
    query.co = countryCode;
  }
  if (searchCriteria == 'country') {
    const country = values.locations
      ?.map((l) => {
        let countryCode;
        if (l.id) {
          countryCode = countryCodeMap[l.id];
        }
        return countryCode;
      })
      .join('+');
    query.rlid = country;
    if (values.zipcode) {
      query.co = values.locations?.map((l) => l.id).join('+');
      query.rpcr = `${values.zipcode.replaceAll(' ', '')}-${values.distance}`;
    }
  }

  if (values.wa && countryCode) {
    query.wa = `${countryCode === 'UK' ? '160' : countryCodeMap[countryCode.toUpperCase()]}-${
      values.wa
    }`;
  }
  if (values.searchType === 'Semantic' && values.wa && values.workAuthCountry) {
    query.workAuthorization = values.workAuthCountry.map((l) => `${l}-${values.wa}`).join(',');
  }

  if (searchCriteria != 'country' && values.locations) {
    const hasZip = values.locations.some((item) => typeof item === 'string' || item.zipCode);
    if (hasZip) {
      const modLocation = values.locations.reduce((cumm: any[], item: any) => {
        if (typeof item === 'string') {
          return [...cumm, ...item.split(',')];
        } else {
          return [...cumm, item];
        }
      }, []);
      query.rpcr = modLocation
        ?.map(
          (l) =>
            `${
              typeof l === 'string' ? l.replace('-', '').replace(' ', '').toLowerCase() : l.zipCode
            }-${values.distance}`
        )
        .join('+');
    } else {
      query.rlid = values.locations?.map((l) => l.id).join('+');
    }
  }

  if (values.targetJobType != '') {
    query[values.targetJobType] = '1';
  }
  if (values.salaryRange) {
    query.tsalmin = values.salaryRange.min;
    query.tsalmax = values.salaryRange.max;
    query.tsalcur = values.salaryRange.currency;
    query.tsaltyp = values.salaryRange.unitTime;
  }
  return query;
}

export const constructPSRXQuery = (values: BasicSearchForm & MonsterSearch) => {
  let country = (values.accountId.substring(values.accountId.indexOf('(')).split('_')[1] ?? '')
    .replace(')', '')
    .trim();
  const query: MonsterSearch = {
    ...values,
    // resumesPostedWithinDays: values.lastActive,
    q: values.query,
    pagesize: values.pageSize,
    modifiedDateMinAge: values.lastActive ? '0' : '',
    modifiedDateMaxAge: values.lastActive,
    clv: values.clvArr ? values.clvArr.join(',') : '',
    gsc: values.gscArr ? values.gscArr.join(',') : '',
    globalSecurityClearance: values.pgscArr
      ? values.pgscArr.map((gscId) => `${country}-${gscId}`).join(',')
      : '',
    gmi: values.gmiArr ? values.gmiArr.join(',') : '',
    qrjt: values.qrjtArr ? values.qrjtArr.join(',') : '',
    qtjt: values.qtjtArr ? values.qtjtArr.join(',') : '',
    qrcn: values.qrcnArr ? values.qrcnArr.join(',') : '',
    qrjd: values.qrjdArr ? values.qrjdArr.join(',') : '',
    qsn: values.qsnArr ? values.qsnArr.join(',') : '',
    legalStatus: values.legalStatusArr?.join(',') ?? '',
  };
  if (values.selectedCountry) {
    query.co = countryMap[values.selectedCountry];
  }

  if (values.tsalmax) {
    const salaryDetails = values.tsalmax.split('-');
    query.targetNormalizedSalMax = salaryDetails[0];
    query.targetSalCurrency = salaryDetails[1];
    query.targetNormalizedSalMin = '0';
    query.targetSalNotIncluded = '1';
  }
  if (values.wa && values.workAuthCountry) {
    query.wa = values.workAuthCountry.map((l) => `${l}-${values.wa}`).join('+');
  }
  if ('europe' === country) {
    country = 'UK';
    query.co = country;
  }
  if (values.searchType === 'Semantic' && values.wa) {
    query.workAuthorization = `${countryCodeMap[country.toUpperCase()]}-${values.wa}`;
  }
  if (values.locations) {
    query.searchLocation = values.locations
      .map((locationData) =>
        locationData.city
          ? `${locationData.city}%2C ${locationData.stateCode}-${values.distance}`
          : locationData.state
          ? `${locationData.state}-${values.distance}`
          : ''
      )
      .join('+');
  }

  if (values.targetJobType != '') {
    query[values.targetJobType] = '1';
  }
  if (values.legalStatusArr) {
    query.legalStatus = values.legalStatusArr
      .map((legalStatus) => `${countryCodeMap[country.toUpperCase()]}-${legalStatus}`)
      .join(',');
  }
  if (values.salaryRange) {
    query.targetNormalizedSalMin = values.salaryRange.min;
    query.targetNormalizedSalMax = values.salaryRange.max;
    query.targetSalCurrency = values.salaryRange.currency;
    query.tsaltyp = values.salaryRange.unitTime;
  }
  if (values.queryType === 'Boolean') {
    query.skills = [values.query];
    query.jobTitles = [];
  }
  return query;
};
